import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import CustomLoading from '../../util_components/custom_loading';
import CustomModal from '../../util_components/custom_modal';
import { FormActions } from '../../util_components/form_layout';
import CustomSingleSelect from '../../util_components/custom_single_select';
import Button from '../../util_components/button';
import { v4 as uuidv4 } from 'uuid';
import { is_valid_reason } from '../../util_components/required_reason_textarea/reason_rules';
import { save_care_request } from '../../util_components/care_request/care_request_api';
import {
  after_care_save,
  care_records_warning,
  care_retry_payloads,
  partial_cancel_message,
  partial_cancel_outcome,
  save_care_records
} from './student_profile/VacationPauseMembership/pause_cancel_payload';
import CareBatchWarningStep from './student_profile/VacationPauseMembership/care_batch_warning';
import RepeatCancelForm from './repeat_cancel/RepeatCancelForm';
import RequestTimeWarningStep from '../../util_components/request_time_warning';
import {
  read_request_time_warning,
  with_request_time_ack
} from '../../util_components/request_time_warning/request_time_warning_rules';
import {
  build_repeat_cancel_request,
  initial_student_fields,
  pick_repeat_side,
  repeat_who_missing,
  repeat_care_records,
  repeat_care_records_for,
  repeat_requested_error
} from './repeat_cancel/repeat_cancel_rules';
import { post_api } from '../../../redux/api_funcs';
import { image_error_replace } from '../../../util_functions';
import {
  session_duration_list,
  tickImageUrl,
  closeImageUrl,
  time_format,
  day_format_year
} from '../../../constants';
import * as actions from '../../../redux/action_creators';
import { get_api_url } from '../../../utils/urls';
import PayTimeWarningStep from '../../util_components/pay_time_warning';
import { read_pay_time_warning } from '../../util_components/pay_time_warning/pay_time_warning_rules';

class RepeatSessions extends Component {
  state = {
    loading: false,
    // A-52: the server's pay-time warning, shown in the open time/duration dialog in place of its form
    pay_warning: null,
    student_uuid: '',
    sessions: [],
    group_sessions: [],
    is_group_cancel: false,
    cancel_session: false,
    cancel_all_future: false,
    cancel_reason: '',
    cancel_reason_error: false,
    ...initial_student_fields(false),
    // Care records not saved, listed on the page with their reason
    care_failed: [],
    // A-52: records goserver refused with PAY_TIME_WARNING, waiting for one acknowledgement
    care_retry: null,
    care_retry_busy: false,
    rt_warning: null,
    session_uuid: '',
    old_start_date: null,
    start_date: null,
    duration: 0,
    edit_session: false,
    change_duration: false,
    new_duration: 60,
    repeat_group_session_participant_id: 0
  };

  componentDidMount() {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const uuid = url.searchParams.get('uuid');
    if (uuid) {
      this.setState({ student_uuid: uuid }, () => this.load_data());
    } else {
      this.props.history.push('/users');
    }
  }

  load_data = () =>
    this.setState({ loading: true }, () => {
      const url = get_api_url('get_all_repeat_sessions');
      const payload = { student_uuid: this.state.student_uuid };
      post_api(url, payload, true).then((res) => {
        this.setState({
          sessions: res.data.yoga_sessions,
          group_sessions: res.data.group_sessions,
          loading: false
        });
      });
    });

  toggle_cancel = () => this.setState({ cancel_all_future: !this.state.cancel_all_future });

  // ack: the request-time acknowledgement from the warning step (A-52). A series has many classes, so
  // there is no client pre-check: apis measures from the series' first booking and answers 409.
  cancel_repeat_session = (ack = null) => {
    // reason is mandatory for payment audit
    const reason_ok = is_valid_reason(this.state.cancel_reason);
    const requested_error = repeat_requested_error(this.state, Date.now());
    const who_error = repeat_who_missing(this.state);
    if (!reason_ok || requested_error || who_error) {
      this.setState({ cancel_reason_error: !reason_ok, requested_error, who_error });
      return;
    }
    // snapshot: close_cancel_session resets the fields the Care records read
    const cancel_state = { ...this.state };
    const { url_key, payload } = build_repeat_cancel_request(cancel_state);
    // the Care records carry the same acknowledgement, so goserver does not warn again
    const with_ack = (records) => records.map((r) => with_request_time_ack(r, ack));
    this.setState({ loading: true, care_failed: [], care_retry: null, rt_warning: null }, () => {
      post_api(get_api_url(url_key), with_request_time_ack(payload, ack), true)
        .then(async (response) => {
          this.close_cancel_session();
          this.props.set_notification_variable(true, 'success', 'Session cancelled');
          // after the cancel commits; a failed record never undoes it
          const records = with_ack(repeat_care_records(cancel_state, response, uuidv4));
          await this.save_care(records);
          this.load_data();
        })
        .catch(async (e) => {
          const rt_warning = read_request_time_warning(e);
          if (rt_warning) {
            this.setState({ loading: false, rt_warning });
            return;
          }
          const err_message =
            e?.response?.data?.message || 'Some error occured. Please contact care team.';
          const partial = partial_cancel_outcome(e);
          if (!partial) {
            this.props.set_notification_variable(true, 'error', err_message);
            this.setState({ loading: false });
            return;
          }
          // partial cancel: record the request time on the classes that did cancel before reporting
          const records = with_ack(
            repeat_care_records_for(cancel_state, partial.cancelled_session_uuids, uuidv4)
          );
          await this.save_care(records);
          this.props.set_notification_variable(
            true,
            'error',
            partial_cancel_message(partial, err_message)
          );
          this.load_data();
        });
    });
  };

  // Saves Care records; pay-time refusals wait for one acknowledgement, the rest are listed with their reason.
  save_care = async (records) => {
    const failed = await save_care_records(records, save_care_request);
    this.setState((prev) => {
      const next = after_care_save(prev.care_failed, failed);
      return { care_failed: next.listed, care_retry: next.retry };
    });
  };

  // One note covers every refused record; each is resent with its own warnings (pay_time_ack).
  ack_care_retry = (note) => {
    const { care_retry } = this.state;
    if (!care_retry || this.state.care_retry_busy) return;
    this.setState({ care_retry_busy: true }, async () => {
      await this.save_care(care_retry_payloads(care_retry.retry, note));
      this.setState({ care_retry_busy: false });
    });
  };

  skip_care_retry = () =>
    this.setState((prev) =>
      prev.care_retry && !prev.care_retry_busy
        ? { care_failed: [...prev.care_failed, ...prev.care_retry.retry], care_retry: null }
        : null
    );

  render_care_retry = () => (
    <CareBatchWarningStep
      retry={this.state.care_retry}
      busy={this.state.care_retry_busy}
      onAcknowledge={this.ack_care_retry}
      onSkip={this.skip_care_retry}
    />
  );

  toggle_cancelled_by_student = () => this.setState((prev) => pick_repeat_side(prev, 'student'));

  toggle_cancelled_by_teacher = () => this.setState((prev) => pick_repeat_side(prev, 'teacher'));

  toggle_cancelled_by_admin = () => this.setState((prev) => pick_repeat_side(prev, 'admin'));

  render_cancel_sessions = () => {
    // a partial cancel keeps this dialog open, so the Care step shows here first
    if (this.state.care_retry) return this.render_care_retry();
    return this.render_cancel_form();
  };

  render_cancel_form = () =>
    this.state.rt_warning ? (
      <RequestTimeWarningStep
        warning={this.state.rt_warning}
        requestedLocal={
          this.state.cancelled_by_teacher
            ? this.state.teacher_requested_at
            : this.state.student_requested_at
        }
        onAcknowledge={(ack) => this.cancel_repeat_session(ack)}
        onChangeTime={() => this.setState({ rt_warning: null })}
      />
    ) : (
      <RepeatCancelForm
        is_group_cancel={this.state.is_group_cancel}
        cancel_all_future={this.state.cancel_all_future}
        cancelled_by_student={this.state.cancelled_by_student}
        student_requested_at={this.state.student_requested_at}
        cancelled_by_teacher={this.state.cancelled_by_teacher}
        cancelled_by_admin={this.state.cancelled_by_admin}
        who_error={this.state.who_error}
        teacher_requested_at={this.state.teacher_requested_at}
        requested_error={this.state.requested_error}
        cancel_reason={this.state.cancel_reason}
        cancel_reason_error={this.state.cancel_reason_error}
        onToggleFuture={this.toggle_cancel}
        onToggleStudent={this.toggle_cancelled_by_student}
        onToggleTeacher={this.toggle_cancelled_by_teacher}
        onToggleAdmin={this.toggle_cancelled_by_admin}
        onTeacherRequestedAtChange={(teacher_requested_at) =>
          this.setState({ teacher_requested_at, requested_error: '' })
        }
        onRequestedAtChange={(e) =>
          this.setState({ student_requested_at: e.target.value, requested_error: '' })
        }
        onReasonChange={(e) =>
          this.setState({ cancel_reason: e.target.value, cancel_reason_error: false })
        }
        onConfirm={() => this.cancel_repeat_session()}
      />
    );

  set_start_date = (date) => this.setState({ start_date: date });

  // ack: the pay-time acknowledgement (A-52); null on the first send
  change_time = (ack = null) => {
    const sel_time = moment(this.state.start_date).format('YYYY-MM-DD HH:mm:ss');
    const epoch_time = moment.tz(sel_time, this.props.iana_timezone).valueOf();
    this.setState({ loading: true }, () => {
      const url = get_api_url('update_repeat_session_time');
      const payload = {
        session_uuid: this.state.session_uuid,
        start_time: epoch_time,
        duration: this.state.duration
      };
      if (ack) payload.pay_time_ack = ack;
      post_api(url, payload, true)
        .then(() => {
          this.load_data();
          this.close_cancel_session();
          this.props.set_notification_variable(
            true,
            'success',
            'Session time updated successfully'
          );
        })
        .catch((e) => {
          const pay_warning = read_pay_time_warning(e);
          this.setState({ loading: false, pay_warning });
          if (pay_warning) return;
          let err_message;
          try {
            err_message = e.response.data.message;
          } catch (err) {
            err_message = 'Some error occured. Please contact care team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
        });
    });
  };

  // ack: the pay-time acknowledgement (A-52); null on the first send
  submit_change_duration = (ack = null) =>
    this.setState({ loading: true }, () => {
      const url = get_api_url('update_repeat_session_duration');
      const payload = {
        session_uuid: this.state.session_uuid,
        duration: this.state.new_duration
      };
      if (ack) payload.pay_time_ack = ack;
      post_api(url, payload, true)
        .then(() => {
          this.load_data();
          this.close_cancel_session();
          this.props.set_notification_variable(true, 'success', 'Duration updated successfully');
        })
        .catch((e) => {
          const pay_warning = read_pay_time_warning(e);
          this.setState({ loading: false, pay_warning });
          if (pay_warning) return;
          let err_message;
          try {
            err_message = e.response.data.message;
          } catch (err) {
            err_message = 'Some error occured. Please contact care team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
        });
    });

  onCommonChange = (e) => {
    const key = e.target.name;
    const { value } = e.target;
    this.setState({ [key]: value });
  };

  // The warning step in place of a dialog's form; Change goes back to the form with its values.
  render_pay_warning = (title, resend) => (
    <div>
      <h4>{title}</h4>
      <PayTimeWarningStep
        warning={this.state.pay_warning}
        busy={this.state.loading}
        onAcknowledge={resend}
        onChange={() => this.setState({ pay_warning: null })}
      />
    </div>
  );

  render_change_duration = () => {
    const { duration, new_duration } = this.state;
    if (this.state.pay_warning) {
      return this.render_pay_warning('Change Duration', (ack) => this.submit_change_duration(ack));
    }
    return (
      <div>
        <h4>Change Duration</h4>
        <CustomSingleSelect
          label="Select session duration"
          options={session_duration_list}
          onChange={this.onCommonChange}
          name="new_duration"
          value={new_duration}
          style={{ width: '250px' }}
        />
        <Button disabled={duration == new_duration} onClick={() => this.submit_change_duration()}>
          Submit
        </Button>
      </div>
    );
  };

  render_edit_sessions = () => {
    const { start_date, old_start_date } = this.state;
    const old_time = moment(old_start_date)
      .tz(this.props.iana_timezone)
      .format('YYYY-MM-DD HH:mm:ss');
    const new_time = moment(start_date).format('YYYY-MM-DD HH:mm:ss');
    if (this.state.pay_warning) {
      return this.render_pay_warning('Change session time', (ack) => this.change_time(ack));
    }
    return (
      <div style={{ minHeight: '400px' }} className="min-w-0 overflow-visible">
        <h3>Change session time</h3>
        <DatePicker
          selected={start_date}
          onChange={(date) => this.set_start_date(date)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={30}
          dateFormat="MMMM d, yyyy h:mm aa"
          popperPlacement="bottom-start"
          popperProps={{ strategy: 'fixed' }}
        />
        <div>
          <Button disabled={old_time === new_time} onClick={() => this.change_time()}>
            Confirm
          </Button>
        </div>
      </div>
    );
  };

  cancel_session = (uuid, is_group_cancel, repeat_group_session_participant_id) => {
    this.setState({
      cancel_session: true,
      session_uuid: uuid,
      is_group_cancel,
      repeat_group_session_participant_id,
      ...initial_student_fields(is_group_cancel)
    });
  };

  edit_session = (uuid, repeat_time, duration) => {
    const curr_date = moment
      .tz(repeat_time, this.props.iana_timezone)
      .format('YYYY-MM-DD HH:mm:ss');
    const curr_time = moment(curr_date).toDate();
    this.setState({
      edit_session: true,
      session_uuid: uuid,
      start_date: curr_time,
      old_start_date: curr_time,
      duration
    });
  };

  change_duration = (uuid, repeat_time, duration) => {
    this.setState({ change_duration: true, session_uuid: uuid, duration, new_duration: duration });
  };

  close_cancel_session = () =>
    this.setState({
      cancel_session: false,
      session_uuid: '',
      cancel_all_future: false,
      cancel_reason: '',
      cancel_reason_error: false,
      ...initial_student_fields(false),
      edit_session: false,
      old_start_date: null,
      start_date: null,
      duration: 0,
      new_duration: 60,
      change_duration: false,
      repeat_group_session_participant_id: 0,
      is_group_cancel: false,
      rt_warning: null,
      pay_warning: null
    });

  render_group_sessions = () => {
    const { group_sessions } = this.state;
    return (
      <div>
        <h3>Group Repeat Sessions</h3>
        {group_sessions.length > 0 ? (
          <div>
            <div className="ct-row ct-h">
              <div className="ct-col">Class Page</div>
              <div className="ct-col">Teacher</div>
              <div className="ct-col">Start Time</div>
              <div className="ct-col ct-hf">Is Active</div>
              <div className="ct-col ct-hf">Cancel</div>
              <div className="ct-col ct-hf">Cancellation Time</div>
            </div>
            {group_sessions.map((session) => {
              const teacher_url = `/teacherprofile?id=${session.teacher_uuid}`;
              const class_page_url = `/group_class_page/${session.group_class_page_slug}`;
              return (
                <div className="ct-row" key={session.id}>
                  <div className="ct-col ct-sm-font">
                    <a className="link-no-dec" href={class_page_url}>
                      <div className="profile-img-name">{session.group_class_page_name}</div>
                    </a>
                  </div>
                  <div className="ct-col ct-sm-font">
                    <a className="link-no-dec" href={teacher_url}>
                      <div className="profile-img-name">
                        <img src="" onError={image_error_replace} alt="x" />
                        {session.teacher_name}
                      </div>
                    </a>
                  </div>
                  <div className="ct-col ct-sm-font">
                    <div>
                      Every{' '}
                      {moment(session.repeat_time)
                        .tz(this.props.iana_timezone)
                        .format('dddd, hh:mm A z')}
                    </div>
                  </div>
                  <div className="ct-col ct-si ct-hf">
                    {session.is_active === 1 ? (
                      <img src={tickImageUrl} alt="tick" />
                    ) : (
                      <img src={closeImageUrl} alt="close" />
                    )}
                  </div>
                  <div className="ct-col ct-hf">
                    {session.is_active === 1 ? (
                      <button
                        className="ct-small-btn"
                        onClick={() => this.cancel_session(null, true, session.id)}
                      >
                        Cancel
                      </button>
                    ) : (
                      '--'
                    )}
                  </div>
                  <div className="ct-col ct-hf ct-sm-font">
                    {session.is_active === 0 ? (
                      <>
                        <div>
                          {moment(session.cancellation_time)
                            .tz(this.props.iana_timezone)
                            .format(day_format_year)}
                        </div>
                        <div>
                          {moment(session.cancellation_time)
                            .tz(this.props.iana_timezone)
                            .format(time_format)}
                        </div>
                      </>
                    ) : (
                      '--'
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  };

  render_sessions = () => {
    const { sessions } = this.state;
    return (
      <div>
        <h3>1-on-1 Repeat Sessions</h3>
        {sessions.length > 0 ? (
          <div className="cus-table" style={{ marginBottom: '20px' }}>
            <div className="ct-row ct-h">
              <div className="ct-col">Teacher</div>
              <div className="ct-col">
                <div>Start Time</div>
                <div className="ct-sm-font">(Dur)</div>
              </div>
              <div className="ct-col ct-hf">Is Active</div>
              <div className="ct-col ct-hf">Cancel</div>
              <div className="ct-col ct-hf">Edit</div>
              <div className="ct-col ct-hf">Change Duration</div>
            </div>
            {sessions.map((session) => {
              const teacher_url = `/teacherprofile?id=${session.teacher_uuid}`;
              return (
                <div className="ct-row" key={session.uuid}>
                  <div className="ct-col ct-sm-font">
                    <a className="link-no-dec" href={teacher_url}>
                      <div className="profile-img-name">
                        <img src="" onError={image_error_replace} alt="x" />
                        {session.teacher_name}
                      </div>
                    </a>
                  </div>
                  <div className="ct-col ct-sm-font">
                    <div>
                      Every{' '}
                      {moment(session.repeat_time)
                        .tz(this.props.iana_timezone)
                        .format('dddd, hh:mm A z')}
                    </div>
                    <div>({session.duration} mins)</div>
                  </div>
                  <div className="ct-col ct-si ct-hf">
                    {session.is_active === 1 ? (
                      <img src={tickImageUrl} alt="tick" />
                    ) : (
                      <img src={closeImageUrl} alt="close" />
                    )}
                  </div>
                  <div className="ct-col ct-hf">
                    {session.is_active === 1 ? (
                      <button
                        className="ct-small-btn"
                        onClick={() => this.cancel_session(session.uuid, false)}
                      >
                        Cancel
                      </button>
                    ) : (
                      '--'
                    )}
                  </div>
                  <div className="ct-col ct-hf">
                    {session.is_active === 1 ? (
                      <button
                        className="ct-small-btn"
                        onClick={() =>
                          this.edit_session(
                            session.original_session_uuid,
                            session.repeat_epoch_time,
                            session.duration
                          )
                        }
                      >
                        Edit
                      </button>
                    ) : (
                      '--'
                    )}
                  </div>
                  <div className="ct-col ct-hf">
                    {session.is_active === 1 ? (
                      <button
                        className="ct-small-btn"
                        onClick={() =>
                          this.change_duration(
                            session.original_session_uuid,
                            session.repeat_epoch_time,
                            session.duration
                          )
                        }
                      >
                        Change
                      </button>
                    ) : (
                      '--'
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    const { change_duration } = this.state;
    return (
      <div className="common-page-container">
        {this.state.loading ? <CustomLoading /> : null}
        <div className="common-page-header">
          <div className="profile-go-back" onClick={() => this.props.history.goBack()}>
            <img
              src="https://s3.amazonaws.com/images.myyogateacher.com/website/home/arrow_back.png"
              alt="back"
            />
            <span>Back</span>
          </div>
          <div className="common-page-title">Repeat sessions</div>
        </div>
        <CustomModal
          show={this.state.cancel_session}
          close={this.close_cancel_session}
          variant="form"
        >
          {this.render_cancel_sessions()}
        </CustomModal>
        <CustomModal
          show={this.state.edit_session}
          close={this.close_cancel_session}
          inner_style={{ minWidth: 440, overflow: 'visible' }}
        >
          {this.render_edit_sessions()}
        </CustomModal>
        <CustomModal show={change_duration} close={this.close_cancel_session}>
          {this.render_change_duration()}
        </CustomModal>
        <CustomModal
          show={!!this.state.care_retry && !this.state.cancel_session}
          close={this.skip_care_retry}
          variant="form"
        >
          {this.state.care_retry ? this.render_care_retry() : null}
        </CustomModal>
        {this.state.care_failed.length ? (
          <p className="myt-form-error">* {care_records_warning(this.state.care_failed)}</p>
        ) : null}
        {this.render_sessions()}
        {this.render_group_sessions()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  iana_timezone: state.home.iana_timezone
});

const mapDispatchToProps = (dispatch) => ({
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(RepeatSessions);
